import styled, { keyframes } from 'styled-components'

import { CaseContainerProps, PaginationDotProps } from './types'
import { FlexContainer } from '@/components'

export const Container = styled(FlexContainer)`
  align-items: flex-start;
  justify-content: space-between;
  display: flex;
  flex: 1;
  flex-direction: row;
  max-width: 1170px;
  height: 500px;
  width: 100%;
  gap: 116px;

  @media (max-width: 1180px) {
    padding: 0 16px;
  }
  @media (max-width: 791px) {
    flex-direction: column;
    gap: 40px;
    height: 100%;
  }
`

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 500px;
  width: 60%;

  gap: 16px;

  .description {
    font-weight: bolder !important;
  }

  @media (max-width: 791px) {
    height: 100%;
    width: 80%;
    .title {
      font-size: ${({ theme }) => theme.fontSizes.h4};
      line-height: 48px;
    }
    .description {
      font-size: ${({ theme }) => theme.fontSizes.b2};
      line-height: 30px;
    }
  }
`

export const CaseContainer = styled.div<CaseContainerProps>`
  display: flex;
  flex-direction: column;
  align-items: flex;
  justify-content: center;
  gap: 8px;
  width: 40%;
  height: 500px;

  @media (max-width: 791px) {
    height: 100%;
    width: 100%;
  }
`

const animateGlow = keyframes`
  0%{background-position:0% 50%}
  50%{background-position:100% 50%}
  100%{background-position:0% 50%}
`
export const SlideContainer = styled.div`
  min-height: 300px;
  width: 100%;
  display: flex;
  align-items: center;

  position: relative;
  z-index: -1;

  &::before {
    content: '';
    display: block;
    z-index: -1;

    position: absolute;
    top: 0;
    right: 0px;

    width: 100%;
    height: 100%;

    animation: ${animateGlow} 7s ease-in-out infinite;
    background: linear-gradient(270deg, #08eddc, #09a8fa);
    background-size: 200% 200%;

    will-change: transform; // pre-optimizes for the blur filter
    filter: blur(110px);

    @media (max-width: 700px) {
      width: 80%;
      height: 80%;
      top: 20px;
      right: 50px;
    }
    @media (max-width: 500px) {
      width: 60%;
      height: 60%;
      top: 60px;
      right: 90px;
    }
  }
`

export const PaginationDot = styled.div<PaginationDotProps>`
  width: 8px;
  height: 8px;
  border-radius: 100%;
  background-color: ${(props) =>
    props.selected ? props.theme.colors.primary : props.theme.colors.white};
  cursor: pointer;

  &:hover {
    background-color: ${(props) => props.theme.colors.primary_2};
  }
`

export const PaginationDotsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: end;
`

export const CasePaginationContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: end;
  gap: 16px;

  @media (max-width: 791px) {
    align-items: center;
  }
`
